// Generous seat count handed out in Platform mode so any seat-limit math passes.
export const PAYWALL_BYPASS_QUANTITY = 9999

// Paywall is ON unless the build was given the exact string "false".
// Anything else (missing/garbled) fails safe to ON.
export const isPaywallEnabled = () => process.env.VUE_APP_PAYWALL_ENABLED !== 'false'
